export var FolderType;
(function(FolderType) {
    FolderType["Collection"] = "collection";
    FolderType["Gallery"] = "gallery";
})(FolderType || (FolderType = {}));
